import useGetSearchResultsBound from "../../../../hooks/useGetSearchResultsBound.js";
import { useDispatch, useSelector } from "react-redux";
import { getFiltersDraft, getFiltersDraftInbound, getFiltersDraftOutbound } from "../../../../store/search/selectors.js";
import { getAvailableFilters } from "../../../../store/searchResults/selectors.js";
import { getAvailableFilters as getOBAvailableFilters } from "../../../../store/searchResultsBounds/outboundSelectors.js";
import { getAvailableFilters as getIBAvailableFilters } from "../../../../store/searchResultsBounds/inboundSelectors.js";
import { actions as searchActions } from "../../../../store/search/actions.js";
import { useCallback } from "react";
export const useGetFiltersDraft = () => {
    const bound = useGetSearchResultsBound();
    const filtersDraft = useSelector(getFiltersDraft);
    const filtersDraftOutbound = useSelector(getFiltersDraftOutbound);
    const filtersDraftInbound = useSelector(getFiltersDraftInbound);
    if (bound === "outbound") {
        return filtersDraftOutbound;
    }
    if (bound === "inbound") {
        return filtersDraftInbound;
    }
    return filtersDraft;
};
export const useGetAvailableFilters = () => {
    const bound = useGetSearchResultsBound();
    const availableFilters = useSelector(getAvailableFilters);
    const availableFiltersOutbound = useSelector(getOBAvailableFilters);
    const availableFiltersInbound = useSelector(getIBAvailableFilters);
    if (bound === "outbound") {
        return availableFiltersOutbound;
    }
    if (bound === "inbound") {
        return availableFiltersInbound;
    }
    return availableFilters;
};
export const useSetFiltersDraft = () => {
    const bound = useGetSearchResultsBound();
    const dispatch = useDispatch();
    return useCallback((filters) => {
        if (bound === "outbound") {
            dispatch(searchActions.setFiltersDraftOutbound(filters));
        }
        else if (bound === "inbound") {
            dispatch(searchActions.setFiltersDraftInbound(filters));
        }
        else {
            dispatch(searchActions.setFiltersDraft(filters));
        }
    }, [bound, dispatch]);
};
export const useResetFiltersDraft = () => {
    const bound = useGetSearchResultsBound();
    const dispatch = useDispatch();
    return useCallback(() => {
        if (bound === "outbound") {
            dispatch(searchActions.resetFiltersDraftOutbound());
        }
        else if (bound === "inbound") {
            dispatch(searchActions.resetFiltersDraftInbound());
        }
        else {
            dispatch(searchActions.resetFiltersDraft());
        }
    }, [bound, dispatch]);
};
export const useApplyFilters = () => {
    const bound = useGetSearchResultsBound();
    const dispatch = useDispatch();
    return useCallback(() => {
        if (bound === "outbound") {
            dispatch(searchActions.applyFiltersOutbound());
        }
        else if (bound === "inbound") {
            dispatch(searchActions.applyFiltersInbound());
        }
        else {
            dispatch(searchActions.applyFilters());
        }
    }, [bound, dispatch]);
};
export const useResetFilters = () => {
    const bound = useGetSearchResultsBound();
    const dispatch = useDispatch();
    return useCallback(() => {
        if (bound === "outbound") {
            dispatch(searchActions.resetFiltersOutbound());
        }
        else if (bound === "inbound") {
            dispatch(searchActions.resetFiltersInbound());
        }
        else {
            dispatch(searchActions.resetFilters());
        }
    }, [bound, dispatch]);
};
export const useResetFilter = () => {
    const bound = useGetSearchResultsBound();
    const dispatch = useDispatch();
    return useCallback((filter) => {
        if (bound === "outbound") {
            dispatch(searchActions.resetFilterOutbound(filter));
        }
        else if (bound === "inbound") {
            dispatch(searchActions.resetFilterInbound(filter));
        }
        else {
            dispatch(searchActions.resetFilter(filter));
        }
    }, [bound, dispatch]);
};
